import React from 'react';
import PortfolioUniversePage from './PortfolioUniversePage';

export default function ModifiedRiskPage() {
  return (
    <PortfolioUniversePage
      strategyId="modified-risk"
      portfolioHoldingType="MODIFIED_RISK"
    />
  );
}
